module.exports = __webpack_public_path__ + "sierra-leone.svg?5b1acf7400d6fefe759cab76d0c9a456";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sierra-leone.svg
// module id = 290
// module chunks = 10